import { render, staticRenderFns } from "./ManageRequestedServicesOfCompanyModal.vue?vue&type=template&id=3d9c153b&"
import script from "./ManageRequestedServicesOfCompanyModal.vue?vue&type=script&lang=ts&"
export * from "./ManageRequestedServicesOfCompanyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports